<template>
  <div class="relative">
    <span @click="toggleModal()" class="cursor-pointer">
      <NameLogo :name="ownerInitials"></NameLogo>
    </span>
    <span class="ml-2">
      <svg class="cursor-pointer" @click="toggleModal()" width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
          <path d="M5.5,6 C5.23993351,6 4.97986701,5.90832554 4.78176949,5.72591207 L0,1.32273152 L1.43646103,0 L5.5,3.74181478 L9.56353897,0 L11,1.32273152 L6.21823051,5.72591207 C6.02013299,5.90832554 5.76006649,6 5.5,6 Z" id="Shape" fill="#2B4864" fill-rule="nonzero"></path>
        </g>
      </svg>
      <div v-show="modalOpened" class="z-10 rounded bg-white shadow-md mt-8 absolute mt-12 pin-t pin-r w-64">
        <span class="flex items-center text-grey-darker text-xs uppercase text-center whitespace-pre h-6 mt-2 ml-2">Transfer Ownership</span>
        <div class="relative">
          <div @click="toggleMenu()" class="h-6 border text-grey-darker text-xs border-grey-light rounded-full flex items-center cursor-pointer justify-center my-4 mx-4 leading-none">{{ownerInitials}}<svg class="cursor-pointer ml-4" width="9px" height="4px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.5">
                <path d="M5.5,6 C5.23993351,6 4.97986701,5.90832554 4.78176949,5.72591207 L0,1.32273152 L1.43646103,0 L5.5,3.74181478 L9.56353897,0 L11,1.32273152 L6.21823051,5.72591207 C6.02013299,5.90832554 5.76006649,6 5.5,6 Z" id="Shape" fill="#2B4864" fill-rule="nonzero"></path>
              </g>
            </svg>
          </div>
          <div v-show="menuOpened" class="z-10 rounded bg-white shadow-md absolute mt-12 pin-t pin-l ml-6 mt-6 w-4/5">
            <ul class="list-reset">
              <li>
                <span @click="toggleOwner('BROKER')" class="cursor-pointer px-4 py-2 block text-grey-darker text-xs text-center hover:bg-navy hover:text-white border border-b">{{brokerName}}</span>
                <span @click="toggleOwner('AGGREGATOR')" class="cursor-pointer px-4 py-2 block text-grey-darker text-xs text-center hover:bg-navy hover:text-white border border-b">{{aggregator.name}}(you)</span>
              </li>
            </ul>
          </div>
          <div class="flex justify-between px-4 mb-4">
            <span @click="confirmChange" class="text-blue cursor-pointer outline-none">Confirm</span>
            <span @click="cancelChange" class="text-grey cursor-pointer outline-none ml-8">Cancel</span>
          </div>
        </div>
      </div>
    </span>
  </div>
</template>

<script>
import NameLogo from '@/components/NameLogo';

export default {
  components: {
    NameLogo,
  },
  data() {
    return {
      modalOpened: false,
      menuOpened: false,
      ownerInitials: 'N A',
      aggregator: {},
      newOwner: '',
    }
  },
  props: {
    currentOwner: {
      type: String,
      default () {
        return ''
      },
    },
    brokerId: {
      type: String,
      default () {
        return ''
      },
    },
    brokerName: {
      type: String,
      default () {
        return ''
      },
    },
    appId: {
      type: String,
      default () {
        return ''
      },
    },
  },
  mounted() {
    this.aggregator = this.$auth.getTokenData()
    this.setInitOwner();
  },
  methods: {
    toggleModal() {
      this.modalOpened = !this.modalOpened;
    },
    toggleMenu() {
      this.menuOpened = !this.menuOpened;
    },
    setInitOwner() {
      if (this.currentOwner === 'BROKER') {
        this.ownerInitials = this.brokerName;
      } else {
        this.ownerInitials = this.aggregator.name;
      }
    },
    toggleOwner(newOwner) {
      if (newOwner === 'BROKER') {
        this.ownerInitials = this.brokerName;
      } else {
        this.ownerInitials = this.aggregator.name;
      }
      this.newOwner = newOwner;
      this.toggleMenu()
    },
    cancelChange() {
      // Reset to original owner
      this.setInitOwner();
      this.toggleModal()
    },
    confirmChange() {
      // do something
      this.$emit('componentEvent', { action: 'changeOwnership', appId: this.appId, newOwner: this.newOwner });
      this.toggleModal();
    },
  },
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TableComponents/DropdownSelector.vue